'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlaylistInfo = exports.setPlaylist = exports.changePlaylistOrder = exports.updatePlaylist = exports.deletePlaylist = exports.createPlaylist = exports.dynamicChangePlaylist = exports.renamePlaylist = exports.findByText = exports.setCurrentSearchText = exports.changeSongChord = exports.changeGlobalState = exports.changeSongProp = exports.changeSongTextPersistent = exports.PL_CREATE_FAILED = exports.PL_UPDATE_FAILED = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = docs;
exports.isPersonsLoaded = isPersonsLoaded;
exports.isSongsLoaded = isSongsLoaded;
exports.loadPersons = loadPersons;
exports.loadSongs = loadSongs;
exports.loadSiblingSongs = loadSiblingSongs;
exports.isDocumentLoaded = isDocumentLoaded;
exports.loadDocument = loadDocument;
exports.loadPlaylists = loadPlaylists;
exports.loadPlaylistData = loadPlaylistData;
exports.setCurrentDoc = setCurrentDoc;

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _utils = require('../../../api/actions/Db/utils');

var _info = require('./info');

var _auth = require('./auth');

var _reduxRouter = require('redux-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//const dispatch => bindActionCreators({pushState, setUiProps, createDialog, changeSongText, changeSongProp, changeGlobalState, changeSongTextPersistent, panelVisibleToSide}, dispatch))


//about redux: https://egghead.io/lessons/javascript-redux-store-methods-getstate-dispatch-and-subscribe
var LOAD_PERSONS = 'redux-example/DOCS_LOAD_PERSONS';
var LOAD_PERSONS_OK = 'redux-example/DOCS_LOAD_PERSONS_OK';

var LOAD_SONGS = 'redux-example/DOCS_LOAD_SONGS';
var LOAD_SONGS_OK = 'redux-example/DOCS_DOCS_LOAD_SONGS_OK';

var LOAD_SIBLING_SONGS = 'redux-example/LOAD_SIBLING_SONGS';
var LOAD_SIBLING_SONGS_OK = 'redux-example/LOAD_SIBLING_SONGS_OK';

var LOAD_DOC = 'redux-example/LOAD_DOC';
var LOAD_DOC_OK = 'redux-example/LOAD_DOC_OK';

var LOAD_FAIL = 'redux-example/DOCS_FAIL';
var SET_CUR_DOC = 'redux-example/SET_CUR_DOC';

//const CHANGE_TEXT = 'redux-example/CHANGE_TEXT';
var CHANGE_CHORD = 'redux-example/CHANGE_CHORD';

var FIND_BY_TEXT = 'redux-example/FIND_BY_TEXT';
var FIND_BY_TEXT_OK = 'redux-example/FIND_BY_TEXT_OK';
var FIND_BY_TEXT_FAIL = 'redux-example/FIND_BY_TEXT_FAIL';

var SET_SEARCH_TEXT = 'redux-example/SET_SEARCH_TEXT';
var PL_RENAME = 'redux-example/PL_RENAME';
var PL_DELETE = 'redux-example/PL_DELETE';
var PL_DELETING = 'redux-example/PL_DELETING';
var PL_CREATING = 'redux-example/PL_CREATING';
var PL_CREATE = 'redux-example/PL_CREATE';
var PL_UPDATING = 'redux-example/PL_UPDATING';
var PL_UPDATED = 'redux-example/PL_UPDATED';
var PL_DYNAMIC = 'redux-example/PL_DYNAMIC';

var LOAD_PLAYLISTS = 'redux-example/LOAD_PLAYLISTS';
var LOAD_PLAYLISTS_OK = 'redux-example/LOAD_PLAYLISTS_OK';
var LOAD_PLAYLISTDATA = 'redux-example/LOAD_PLAYLISTSDATA';
var LOAD_PLAYLISTDATA_OK = 'redux-example/LOAD_PLAYLISTSDATA_OK';

var DYNAMIC = 'redux-example/docs/DYNAMIC';
var DYNAMICTEST = 'redux-example/docs/DYNAMICTEST';

var PL_UPDATE_FAILED = exports.PL_UPDATE_FAILED = 'redux-example/PL_UPDATED_FAILED';
var PL_CREATE_FAILED = exports.PL_CREATE_FAILED = 'redux-example/PL_CREATE_FAILED';

var PL_ORDER = 'redux-example/PL_ORDER'; // zmena poradi v playlistu
var PL_SET = 'redux-example/PL_SET'; // pridani nebo odebrani pisne z playlistu

var newSongText = '1:\n C# F# {jiná značka mezi akordy} Bb\ntext text.....\n\R:\n F#  Cm7\ntext refren\n2:\ntext text\n*:\ntext bridge\n\R:\n\n3:\ntext text...\n[:opakovaný text - repetice:]\n\nhttps://www.youtube.com/watch?v=VOgFZfRVaww';

var initialState = {
  loaded: false,
  songsByPersonCache: {},
  documentCache: { 'newSong': { name: 'Nová píseň', text: newSongText, id: 'newSong', interprets: [] } },
  playLists: [] /*playlisty uzivatele*/
  , publicPlaylists: null /*verejne playlisty */
};

var localeComparator = function localeComparator(obj1, obj2) {
  return obj1.name.localeCompare(obj2.name);
};
var minChars = _config2.default.appSettings.minSearchTextLength;

var loadPlaylistsOk = function loadPlaylistsOk(state, action) {
  var pls = action.result;
  var newState = (0, _extends3.default)({}, state, { publicPlaylists: pls
  });
  return newState;
};

var loadPlaylistsDataOk = function loadPlaylistsDataOk(state, arrivedPlaylists, arrivedHasPriority) {
  var newState = (0, _extends3.default)({}, state, {
    playLists: arrivedHasPriority ? (0, _utils.merge2ArrayByKey)(arrivedPlaylists, state.playLists, function (pl) {
      return pl.id;
    }, localeComparator) : (0, _utils.merge2ArrayByKey)(state.playLists, arrivedPlaylists, function (pl) {
      return pl.id;
    }, localeComparator),
    songsByPersonCache: (0, _extends3.default)({}, state.songsByPersonCache)

  });
  // pisne z  playlistu uzivatele jsou pridany do cachí písní
  newState.playLists.forEach(function (pl) {
    newState.songsByPersonCache['p:' + pl.id] = pl.songs;
  });
  //jeste prekontrolujeme, zda se nezmenila verejna viditelnost
  if (state.publicPlaylists) {
    var changed = false;
    var newPublicPlaylists = state.publicPlaylists;
    newState.playLists.forEach(function (pl) {
      //playlist je zaroven verejnym playlistem
      var pubPl = (0, _utils.firstOrNull)(newPublicPlaylists, function (pubPl) {
        return pubPl.id === pl.id;
      });
      if (pubPl) {
        //verejny playlist existuje, ale nyni uz neni verejny
        if (!(pl.public && pl.visible)) {
          newPublicPlaylists = newPublicPlaylists.filter(function (x) {
            return x.id !== pubPl.id;
          });changed = true;
        }
      } else {
        //verejny plalist jsme nenasli, ale playlist je nyni verejny
        if (pl.public && pl.visible) {
          newPublicPlaylists = (0, _utils.merge2ArrayByKey)([pl], newPublicPlaylists, function (pl) {
            return pl.id;
          }, localeComparator), changed = true;
        }
      }
    });
    if (changed) return (0, _extends3.default)({}, newState, { publicPlaylists: newPublicPlaylists });
  }
  return newState;
};

function docs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _auth.LOGIN_SUCCESS:
      var pls = action.result.data.playLists;
      return loadPlaylistsDataOk(state, pls, false);

    case _auth.LOGOUT_SUCCESS:
      var newStateLogout = (0, _extends3.default)({}, state, {
        playLists: [],
        songsByPersonCache: (0, _extends3.default)({}, state.songsByPersonCache)
      });
      state.playLists.forEach(function (pl) {
        newStateLogout.songsByPersonCache['p:' + pl.id] = [];
      });
      return newStateLogout;
    case PL_RENAME:
      var oldOne = state.playLists.filter(function (pl) {
        return pl.id === action.id;
      })[0];
      var newOne = (0, _extends3.default)({}, oldOne, { name: action.name });
      var newStateRen = (0, _extends3.default)({}, state, {
        playLists: [].concat((0, _toConsumableArray3.default)(state.playLists.filter(function (pl) {
          return pl.id !== action.id;
        })), [newOne])
      });
      newStateRen.playLists.sort(localeComparator);
      return newStateRen;
    case PL_CREATE:
      var id = action.result.id;
      var newStatePlCreate = (0, _extends3.default)({}, state, {
        playLists: [].concat((0, _toConsumableArray3.default)(state.playLists), [{ name: action.result.name, id: id }]),
        songsByPersonCache: (0, _extends3.default)({}, state.songsByPersonCache)
      });
      newStatePlCreate.songsByPersonCache['p:' + id] = [];
      newStatePlCreate.playLists.sort(localeComparator);
      return newStatePlCreate;
    // case PL_CREATE_FAILED:
    //  const newStatePlFailed = {
    //    ...state,
    //  }
    //  return newStatePlFailed;
    case PL_UPDATING:
      return (0, _extends3.default)({}, state, { savingPlaylist: true });
    case PL_UPDATE_FAILED:
      return (0, _extends3.default)({}, state, { savingPlaylist: false });
    case PL_UPDATED:
      if (action.result === false) return (0, _extends3.default)({}, state, { savingPlaylist: false }); // nedoslo k zadne zmene
      //const idUpd = action.result.id;
      return (0, _extends3.default)({}, loadPlaylistsDataOk(state, [action.result], true), { savingPlaylist: false });
    // const newStatePlUpd = {
    //   ...state,
    //   savingPlaylist: false,
    //   playLists: [...(state.playLists).filter(pl => pl.id !== idUpd), { name: action.result.name, id: idUpd }],
    //   songsByPersonCache: { ...state.songsByPersonCache }
    // };
    // newStatePlUpd.songsByPersonCache['p:' + idUpd] = action.result.songs;
    // newStatePlUpd.playLists.sort(localeComparator);
    // return newStatePlUpd;
    case PL_DELETE:
      var newStatePlDelete = (0, _extends3.default)({}, state, {
        playLists: [].concat((0, _toConsumableArray3.default)(state.playLists.filter(function (pl) {
          return pl.id !== action.result.id;
        }))),
        songsByPersonCache: (0, _extends3.default)({}, state.songsByPersonCache)
      });
      var plId3 = 'p:' + action.result.id;
      delete newStatePlDelete.songsByPersonCache[plId3];
      // const indexToDelete = newStatePlDelete.playLists.findIndex(pl=>pl.id === action.id);
      // newStatePlDelete.playLists.splice(indexToDelete, 1);
      return newStatePlDelete;
    case PL_ORDER:
      var newStateOrder = (0, _extends3.default)({}, state, {
        songsByPersonCache: (0, _extends3.default)({}, state.songsByPersonCache)
      });
      var plId = 'p:' + action.playlistId;
      var items = newStateOrder.songsByPersonCache[plId];
      var songIndex = items.findIndex(function (song) {
        return song.id === action.songId;
      });
      var reordereditems = (0, _utils.arrayMove)(items, songIndex, songIndex + action.direction); // eslint-disable-line 
      newStateOrder.songsByPersonCache[plId] = reordereditems;
      return newStateOrder;
    case PL_SET:
      var newStatePlSet = (0, _extends3.default)({}, state, {
        songsByPersonCache: (0, _extends3.default)({}, state.songsByPersonCache)
      });
      var plId2 = 'p:' + action.playlistId;
      var items2 = newStatePlSet.songsByPersonCache[plId2];
      var songIndex2 = items2.findIndex(function (song) {
        return song.id === action.songXid;
      });
      if (action.action === 'add') {
        // v pripade 'remove' state.documentCache[action.songXid] nemusí existovat
        var songName = state.documentCache[action.songXid].name;
        if (songIndex2 !== -1) return state; // alredy in playlist
        var newItemsPlSet = [].concat((0, _toConsumableArray3.default)(items2), [{ name: songName, id: action.songXid }]);
        newStatePlSet.songsByPersonCache[plId2] = newItemsPlSet;
        return newStatePlSet;
      }
      if (action.action === 'remove') {
        var _newItemsPlSet = [].concat((0, _toConsumableArray3.default)(items2));
        _newItemsPlSet.splice(songIndex2, 1);
        newStatePlSet.songsByPersonCache[plId2] = _newItemsPlSet;
        return newStatePlSet;
      }
      return state;
    case PL_DYNAMIC:
      var oldOnePlDyn = state.playLists.filter(function (pl) {
        return pl.id === action.id;
      })[0];
      var clonedPlDyn = (0, _extends3.default)({}, oldOnePlDyn);
      action.changeAction(clonedPlDyn);
      var newStatePlDyn = (0, _extends3.default)({}, state, {
        playLists: [].concat((0, _toConsumableArray3.default)(state.playLists.filter(function (pl) {
          return pl.id !== action.id;
        })), [clonedPlDyn])
      });
      newStatePlDyn.playLists.sort(localeComparator);
      return newStatePlDyn;

    case LOAD_PERSONS:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_PERSONS_OK:
      action.result.docs.persons.sort(localeComparator);
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case FIND_BY_TEXT_OK:
      var _action$result = action.result,
          foundDocs = _action$result.foundDocs,
          searchText = _action$result.searchText;

      if (searchText != state.searchText) {
        // eslint-disable-line 
        return state; // přišlo to pozdě, uživatel změnil vstup
      }
      return (0, _extends3.default)({}, state, {
        searched: state.searchText && state.searchText.length >= minChars ? foundDocs : null, // muze být prazdné pole (nic nenalezeno), nebo null (hledání ukončeno)
        searchedLastText: searchText
      });
    case SET_SEARCH_TEXT:
      return (0, _extends3.default)({}, state, { searchText: action.searchText });
    case LOAD_SONGS_OK:
      // console.log('LOAD_SONGS_OK');
      if (action.result.songs.length === 0) return state;
      var newState0 = (0, _extends3.default)({}, state, { songsByPersonCache: (0, _extends3.default)({}, state.songsByPersonCache)
      });
      action.result.songs.sort(localeComparator);
      newState0.songsByPersonCache[action.result.personId] = action.result.songs;
      return newState0;
    case LOAD_SIBLING_SONGS_OK:
      // legacy nahrávání dle mongoXidu
      // console.log('LOAD_SONGS_OK');
      var newState2 = (0, _extends3.default)({}, state, { songsByPersonCache: (0, _extends3.default)({}, state.songsByPersonCache), documentCache: (0, _extends3.default)({}, state.documentCache)
      });
      newState2.songsByPersonCache[action.result.personId] = action.result.songs;
      newState2.legacyPush = action.result.legacyPush;
      if (action.result.legacyPush.song) {
        newState2.documentCache[action.result.legacyPush.song.xid] = action.result.legacyPush.song;
        newState2.documentCache[action.result.legacyPush.song.xid].custom = {};
        action.result.legacyPush.songXid = action.result.legacyPush.song.xid;
        // legacyPush objekt už nemusí obsahovat objekt písně -> je už v 'documentCache'
        delete action.result.legacyPush.song;
      } else {
        // documentCache nebylo treba klonovat, šlo by asi udelat lepeji:
        newState2.documentCache = state.documentCache;
      }

      return newState2;
    case LOAD_DOC_OK:
      var document = action.result;
      //if (!document.custom) document.custom = {};
      // document.songObj = converter.convertToAgama(document.text);
      // document.custom.html = document.songObj.getHtml();
      // const html2 = songObj.getHtml(); // JSON.stringify(songObj, null, 2);
      var newState1 = (0, _extends3.default)({}, state, { documentCache: (0, _extends3.default)({}, state.documentCache)
      });
      //alert(JSON.stringify(document,null,1));
      var key = (0, _utils.getCombinedKey)(document.xid, document.id);
      newState1.documentCache[key] = document;
      if (document.isLast) {
        newState1.documentCache[(0, _utils.getCombinedKey)(document.xid, null)] = document;
      }
      // cache obsahuje jako klíč xid, asi by to chtelo i nejak s id

      // if (!newState1.documentCache[action.result.xid].custom) newState1.documentCache[action.result.xid].custom = {};
      return newState1;
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case LOAD_PLAYLISTS_OK:
      return loadPlaylistsOk(state, action);
    case LOAD_PLAYLISTDATA_OK:
      return loadPlaylistsDataOk(state, action.result /*muze byt null, treba kvuli pravum*/ ? [action.result] : [], false);
    case SET_CUR_DOC:
      alert(action.currentId); // nepouziva se
      var newState = (0, _extends3.default)({}, state, { currentId: action.currentId, currentDocType: action.currentDocType
      });
      return newState;
    case CHANGE_CHORD:
      var newState8 = (0, _extends3.default)({}, state, { documentCache: (0, _extends3.default)({}, state.documentCache) });
      var newDoc8 = (0, _extends3.default)({}, newState8.documentCache[action.xid]);
      var newCustom8 = (0, _extends3.default)({}, newDoc8.custom);
      newCustom8.chordBase = 'C';
      newDoc8.custom = newCustom8;
      newState8.documentCache[action.xid] = newDoc8;
      return newState8;

    //     case CHANGE_TEXT:
    // // alert(action.xid + '\n' + action.text);
    // if (state.documentCache[action.xid].text === action.text) {
    //   // text je nyni stejný jako na zacatku:
    //   if (state.documentCache[action.xid].custom.newText == null) {// eslint-disable-line eqeqeq
    //     // nedošlo doposud ke změně
    //     return state;
    //   }
    //   const newState7 = {...state, documentCache: {...state.documentCache } };
    //   const newDoc7 = {...newState7.documentCache[action.xid] };
    //   const newCustom7 = {...newDoc7.custom };
    //   delete newCustom7.newText; // = odstraníme neuložený text (je stejný jako na zacatku)
    //   newDoc7.custom = newCustom7;
    //   // newDoc7.songObj = converter.convertToAgama(action.text);
    //   // newDoc7.custom.html = newDoc7.songObj.getHtml();
    //   newState7.documentCache[action.xid] = newDoc7;
    //   return newState7;
    // }
    // // ulozime novy 'dočasný' text
    // const newState6 = {
    //         ...state, documentCache: {...state.documentCache }
    //       };

    // // newText..novy 'dočasný' text - hodnota se rendruje v Textareře;
    // const newDoc6 = {...newState6.documentCache[action.xid] };
    // const newCustom6 = {...newDoc6.custom, newText: action.text };
    // newDoc6.custom = newCustom6;
    // // newDoc6.songObj = converter.convertToAgama(action.text);
    // // newDoc6.xxx = 10;
    // // newDoc6.custom.html = newDoc6.songObj.getHtml();
    // // newDoc6.custom.xxx = 11;
    // newState6.documentCache[action.xid] = newDoc6;
    // return newState6;

    case DYNAMIC:
      //payload akce je menici metoda 'changeStatePure'
      var changeStatePure = action.changeStatePure,
          client = action.client,
          next = action.next;

      var newStateDyn = changeStatePure(state, client, next);
      return newStateDyn;

    case DYNAMICTEST:
      //payload akce je menici metoda 'changeStatePure'
      alert('DOKONCENOX');
      return state;

    default:
      return state;
  }
}

var isNewPerson = function isNewPerson(id) {
  return id.startsWith('-');
};

//void 
var doplnNoveInterprety = function doplnNoveInterprety(postData, state) {
  if (!postData.interprets) return;
  var newObjects = postData.interprets.filter(isNewPerson).map(function (personId) {
    return {
      name: state.data.docs.persons.filter(function (x) {
        return x.id === personId;
      })[0].name,
      typeId: 'Person',
      id: personId /* pouze pro parovavni s daty u pisne */
    };
  });
  if (newObjects.length > 0) postData.newItems = newObjects;
};

var updateDocumentCache = function updateDocumentCache(res, state) {};

//ulozi zmeny pisne na server
var changeSongTextPersistent = exports.changeSongTextPersistent = function changeSongTextPersistent(xid, id, typeId, mode, onDone) {

  return {
    type: DYNAMIC,
    changeStatePure: function changeStatePure(state, client, next) {

      var newState = (0, _extends3.default)({}, state, { documentCache: (0, _extends3.default)({}, state.documentCache) });
      var newDoc = (0, _extends3.default)({}, newState.documentCache[xid]);
      var newCustom = (0, _extends3.default)({}, newDoc.custom); // pro jine priznaky
      newCustom.isSaving = true;

      var postData = mode === 'update' ? (0, _assign2.default)({ xid: xid, typeId: typeId, id: id }, newDoc.changes) : (0, _assign2.default)({ typeId: typeId }, newDoc.changes);

      doplnNoveInterprety(postData, state);

      var createNextAction = function createNextAction(res) {
        return {
          type: DYNAMIC,
          changeStatePure: function changeStatePure(state) {
            if (res == null /*nedošlo ke změně*/) {
                var newState5 = (0, _extends3.default)({}, state, { documentCache: (0, _extends3.default)({}, state.documentCache) });
                var newDoc5 = (0, _extends3.default)({}, newState5.documentCache[xid]);
                var newCustom5 = (0, _extends3.default)({}, newDoc5.custom);
                newCustom5.isSaving = false;
                newDoc5.custom = newCustom5;
                newState5.documentCache[xid] = newDoc5;
                var action5a = function action5a() {
                  return next((0, _info.createDialog)({
                    title: 'Info',
                    msg: 'Nedošlo ke změně / Not changed',
                    okBtnText: 'OK',
                    onClick: null,
                    onNoClick: null,
                    ico: 'ok'
                  }));
                };
                setTimeout(action5a, 100);

                var action5b = function action5b() {
                  return next((0, _info.closeDialog)());
                };
                //asi nelze jinak, ale lepsi by bylo volat zpet do GUI
                setTimeout(action5b, 2000);
                return newState5;
              }

            var newState = (0, _extends3.default)({}, state, { documentCache: (0, _extends3.default)({}, state.documentCache) });

            if (postData.newItems) {
              //všechny docasne pouzite polozky smažeme, protoze byly vytvoreny na serveru již doopravdy s realnymi id
              var toRemove = postData.newItems.map(function (x) {
                return x.id;
              });
              var filter = function filter(p) {
                return toRemove.indexOf(p.id) === -1;
              };
              newState.data.docs.persons = [].concat((0, _toConsumableArray3.default)(state.data.docs.persons.filter(filter)));
            }
            //a nove naopak pridame
            var toAdd = res.filter(function (x) {
              return x.type === 'Person';
            }).map(function (p) {
              return { id: p.xid, lastId: p.id, used: true, name: p.name };
            });
            if (toAdd.length > 0) {
              newState.data.docs.persons = [].concat((0, _toConsumableArray3.default)(state.data.docs.persons.concat(toAdd)));
              newState.data.docs.persons.sort(localeComparator);
            }
            var newDoc = void 0;
            if (xid === 'newSong') {
              //vycistime zmeny v novem dokumentu pro nove pridavani
              var empty = (0, _extends3.default)({}, newState.documentCache[xid]);
              delete empty.changes;
              delete empty.custom;
              newState.documentCache[xid] = empty;
              //vznikl novy dokument (ten posledni)
              newDoc = res[res.length - 1];
              newDoc.isLast = true;
              newState.documentCache[newDoc.xid] = newDoc;
            } else {
              //jen update
              newDoc = res.filter(function (x) {
                return x.xid === xid;
              })[0];
              newDoc.isLast = true;
              newState.documentCache[xid] = newDoc;
            }
            newState.songsByPersonCache = (0, _extends3.default)({}, newState.songsByPersonCache);
            //pro vsechny nove inteprety upravime seznam v levem stromě
            newDoc.interprets.forEach(function (personXid) {
              //const toRenew = newState.songsByPersonCache[xid].filter(x=>x.id===xid).select(x=>x.;
              var newItem = { id: xid, lastId: newDoc.id, interpretId: newDoc.interprets, name: newDoc.name };
              var oldList = newState.songsByPersonCache[personXid];
              if (oldList) {
                //jiz existuje nacechovany seznam od daneho interpreta.
                newState.songsByPersonCache[personXid] = oldList.filter(function (x) {
                  return x.id !== xid;
                }).concat(newItem);
                newState.songsByPersonCache[personXid].sort(localeComparator);
              }

              //delete newState.songsByPersonCache[xid];
            });

            var newUrlInterpatName = newState.data.docs.persons.filter(function (x) {
              return x.id == newDoc.interprets[0];
            })[0].name;
            var newUrl = '/' + newDoc.interprets[0] + '/' + (0, _utils.frindlyName)(newUrlInterpatName) + '/' + newDoc.xid + '/' + (0, _utils.frindlyName)(newDoc.name);
            var action = function action() {
              return next((0, _info.createDialog)({
                title: 'Uloženo',
                msg: 'Uloženo',
                okBtnText: 'OK',
                onClick: function onClick() {
                  onDone(newUrl);
                },
                onNoClick: null,
                ico: 'ok'

              }));
            };
            //asi nelze jinak, ale lepsi by bylo volat zpet do GUI
            setTimeout(action, 100);

            return newState;
          }
        };
      };
      var createNextErrorAction = function createNextErrorAction(e) {
        return {
          type: DYNAMIC,
          changeStatePure: function changeStatePure(state) {
            //alert('Any error during saving document...');
            var newState = (0, _extends3.default)({}, state, { documentCache: (0, _extends3.default)({}, state.documentCache) });
            var newDoc = (0, _extends3.default)({}, newState.documentCache[xid]);
            var newCustom = (0, _extends3.default)({}, newDoc.custom);
            newCustom.isSaving = false;
            newDoc.custom = newCustom;
            newState.documentCache[xid] = newDoc;

            var action = function action() {
              return next((0, _info.createDialog)({
                title: 'Chyba / Error',
                msg: e.priorityMessage || e.message || 'Unknown error.',
                okBtnText: 'OK',
                onClick: function onClick() {},
                onNoClick: null,
                ico: 'alert'

              }));
            };
            //asi nelze jinak, ale lepsi by bylo volat zpet do GUI
            setTimeout(action, 100);

            return newState;
          }
        };
      };

      client.post('/' + mode + 'Document', {
        data: postData
      }).then(function (res) {
        next(createNextAction(res));return res;
      }).then(function (res) {
        //if (onDone) onDone(res);
      }).catch(function (e) {
        return next(createNextErrorAction(e));
      });

      newDoc.custom = newCustom;
      newState.documentCache[xid] = newDoc;
      return newState;
    }
  };
};

//provede lokalni zmenu aktualni pisne, akci volá již na naklonované písní
var changeSongProp = exports.changeSongProp = function changeSongProp(xid, changeAction) {
  return {
    type: DYNAMIC,
    changeStatePure: function changeStatePure(state) {

      var newState = (0, _extends3.default)({}, state, { documentCache: (0, _extends3.default)({}, state.documentCache) });
      var newDoc = (0, _extends3.default)({}, newState.documentCache[xid]);
      var newCustom = (0, _extends3.default)({}, newDoc.custom); // pro jine priznaky
      var newChanges = (0, _extends3.default)({}, newDoc.changes || {}); //pro soubory zmen
      newDoc.custom = newCustom;
      newDoc.changes = newChanges;
      changeAction(newDoc);
      newState.documentCache[xid] = newDoc;
      return newState;
    }
  };
};

//provede globalni zmenu stavu, funkce musi vratit novy stav
var changeGlobalState = exports.changeGlobalState = function changeGlobalState(changeFunction /*prechodova fce pro zmenu stavu*/) {
  return {
    type: DYNAMIC,
    changeStatePure: changeFunction
  };
};

function isPersonsLoaded(globalState) {
  return globalState.docs && globalState.docs.loaded;
}

function isSongsLoaded(globalState, personId) {
  return globalState.docs && globalState.docs.loaded && globalState.docs.songsByPersonCache[personId];
}

function loadPersons() {
  return {
    types: [LOAD_PERSONS, LOAD_PERSONS_OK, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/loadPersons');
    }
  };
}

function loadSongs(personId) {
  return {
    types: [LOAD_SONGS, LOAD_SONGS_OK, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/loadSongs?personId=' + personId);
    }
  };
}

function loadSiblingSongs(oldFormatDocumentId) {
  return {
    types: [LOAD_SIBLING_SONGS, LOAD_SIBLING_SONGS_OK, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/loadSiblingSongs?oldFormatDocumentId=' + oldFormatDocumentId);
    }
  };
}

function isDocumentLoaded(globalState, xid, versionId) {
  var key = (0, _utils.getCombinedKey)(xid, versionId);
  return globalState.docs && globalState.docs.loaded && globalState.docs.documentCache[key];
}

function loadDocument(xid, versionId) {
  var q = '/loadDocument?docId=' + xid;
  if (versionId) q += '&versionId=' + versionId;
  return {
    types: [LOAD_DOC, LOAD_DOC_OK, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(q);
    }
  };
}

//nahrava verejne playlisty
function loadPlaylists() {
  return {
    types: [LOAD_PLAYLISTS, LOAD_PLAYLISTS_OK, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/loadPlayLists');
    }
  };
}

function loadPlaylistData(id) {
  return {
    types: [LOAD_PLAYLISTDATA, LOAD_PLAYLISTDATA_OK, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/loadPlayList?playListId=' + id);
    }
  };
}

// nepouziva se
function setCurrentDoc(currentId, currentDocType) {
  return {
    type: SET_CUR_DOC,
    currentId: currentId,
    currentDocType: currentDocType
  };
}

// //obsolete
// export const changeSongText = (xid, text) => {
//   return {
//     type: CHANGE_TEXT,
//     xid: xid,
//     text: text
//   };
// };


var changeSongChord = exports.changeSongChord = function changeSongChord(xid, baseChord) {
  return {
    type: CHANGE_CHORD,
    xid: xid,
    baseChord: baseChord
  };
};

var setCurrentSearchText = exports.setCurrentSearchText = function setCurrentSearchText(searchText) {
  return {
    type: SET_SEARCH_TEXT,
    searchText: searchText
  };
};

var findByText = exports.findByText = function findByText(text) {
  return {
    types: [FIND_BY_TEXT, FIND_BY_TEXT_OK, FIND_BY_TEXT_FAIL],
    promise: function promise(client) {
      return client.get('/findByText?text=' + text).then(function (result) {
        return { foundDocs: result, searchText: text };
      });
    }

  };
};

var renamePlaylist = exports.renamePlaylist = function renamePlaylist(id, name) {
  return {
    type: PL_RENAME,
    id: id,
    name: name
  };
};
var dynamicChangePlaylist = exports.dynamicChangePlaylist = function dynamicChangePlaylist(id, changeAction) {
  return {
    type: PL_DYNAMIC,
    id: id,
    changeAction: changeAction
  };
};
// uzivatel vytvori playlist sam sobe
var createPlaylist = exports.createPlaylist = function createPlaylist(name) {
  return {
    types: [PL_CREATING, PL_CREATE, PL_CREATE_FAILED],
    promise: function promise(client) {
      return client.post('/createPlayList', {
        data: {
          name: name
        }
      });
    }
  };
};

var deletePlaylist = exports.deletePlaylist = function deletePlaylist(id) {
  var onDone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    types: [PL_DELETING, PL_DELETE, PL_CREATE_FAILED], // todo: svoji akci pri chybe
    promise: function promise(client) {
      return client.post('/deletePlayList', {
        data: {
          id: id
        }
      }).then(function () {
        if (onDone) onDone();
      }).then(function () {
        return { id: id };
      });
    }
  };
  // return {
  //   type: PL_DELETE,
  //   id: id
  // };
};

// vola se z playlist editoru (tlacitko ulozit)
var updatePlaylist = exports.updatePlaylist = function updatePlaylist(changes) {
  return {
    types: [PL_UPDATING, PL_UPDATED, PL_UPDATE_FAILED], // todo: svoji akci pri chybe
    promise: function promise(client) {
      return client.post('/updatePlayList', {
        data: {
          changes: changes
        }
      });
    }
  };
};

var changePlaylistOrder = exports.changePlaylistOrder = function changePlaylistOrder(playlistId, songId, direction) {
  return {
    type: PL_ORDER,
    playlistId: playlistId,
    songId: songId,
    direction: direction
  };
};

var setPlaylist = exports.setPlaylist = function setPlaylist(playlistId, songXid, action) {
  var onlyOnClient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (onlyOnClient) {
    return { // nebudeme volat server
      type: PL_SET, songXid: songXid, action: action, playlistId: playlistId
    };
  }
  var changes = { id: playlistId };
  changes[action] = songXid;
  return {
    types: [PL_SET, PL_UPDATED, PL_CREATE_FAILED], // todo: svoji akci pri chybe
    playlistId: playlistId,
    songXid: songXid,
    action: action,
    promise: function promise(client) {
      return client.post('/updatePlayList', {
        data: {
          changes: changes
        }
      });
    }

  };
};

var getPlaylistInfo = exports.getPlaylistInfo = function getPlaylistInfo(stateDocs, playlistId, songXid) {
  var plId = 'p:' + playlistId;
  var pl = stateDocs.loaded && stateDocs.songsByPersonCache[plId];
  var index = pl.findIndex(function (song) {
    return song.id === songXid;
  });
  return {
    exists: index !== -1,
    position: index,
    total: pl.length
  };
};

// export function changeSongText(xid, text) {
//   return {
//     type: CHANGE_TEXT,
//     xid: xid,
//     text: text
//   };
// }


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/docs.js
// module id = 53
// module chunks = 0